function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStaffGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4",
    width: 21.166666,
    height: 21.166666,
    x: -2.8421709e-14,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#4e79a7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-2",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229218,
    y: 277.15619,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.13229166,
      strokeOpacity: 1
    },
    d: "m 5.9531444,284.29995 c -2.25224,0 -2.51753,2.11666 -4.89479,2.11666 l 0.26458,2.11667 c 2.36399,0 2.93318,-2.11667 4.63021,-2.11667 1.69702,0 2.26621,2.11667 4.6301996,2.11667 2.364,0 2.8417,-2.11667 4.63021,-2.11667 1.85532,0 2.26622,2.11667 4.63021,2.11667 l 0.26459,-2.11667 c -2.37726,0 -2.64257,-2.11666 -4.8948,-2.11666 -2.25223,0 -2.65385,2.11667 -4.63021,2.11667 -1.9095396,0 -2.3779696,-2.11667 -4.6301996,-2.11667 z",
    id: "rect6560-6-4-2-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.28868407,
      strokeOpacity: 1
    },
    d: "m 9.2604344,279.27287 v 8.33075 c 0.37654,0.23512 0.7935996,0.4005 1.3229096,0.4005 0.53388,0 0.95135,-0.15695 1.32292,-0.38241 v -0.41134 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79427 h -1.21595 v -0.79375 h 1.21595 v -0.79323 z m 0,10.58384 v 6.08491 h 2.6458296 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.79375 h 1.21595 v -0.79375 h -1.21595 v -0.27079 c -0.0366,0.001 -0.0695,0.006 -0.10697,0.006 -0.51809,0 -0.9464696,-0.10529 -1.3229096,-0.26407 z",
    id: "rect8773-0-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaffGauge);
export default __webpack_public_path__ + "static/media/icon-staff-gauge.41c084c8c58229f9d0e11a3e6a0e63f5.svg";
export { ForwardRef as ReactComponent };